import store from '@carvana/purchase-store';
import * as types from './action-types';

export const TrackEvent = payload =>
  store.dispatch({
    type: types.TRACK_PURCHASE_UI,
    payload
  });

export const EventTracked = () =>
  store.dispatch({
    type: types.TRACKED
  });
